import classNames from "classnames";
import { Select } from "@/components";
import { IoMdClose } from "react-icons/io";
import { Address } from "@/types";
import { makeAddress, reduceString } from "@/utils";
import "./style.scss";
interface Props {
  manageMode?: boolean;
  projectAddresses: Address[];
  selectedAddresses: Address[];
  onSetSelectedAddresses(addresses: Address[]): void;
  isLoading?: boolean;
  onUpdate?(): void;
  className?: string;
  onNewAddress?(): void;
  onSelectAddress?(addr: Address): void;
  readOnly?: boolean;
}

export const AddressBook = ({
  projectAddresses,
  selectedAddresses,
  onSetSelectedAddresses,
  className,
  onNewAddress = () => {},
  onSelectAddress = () => {},
  readOnly = false,
}: Props) => {
  const unSelectedAddresses = projectAddresses.filter((address) => {
    return !selectedAddresses
      .map((selectedAddress) => {
        return selectedAddress.id;
      })
      .includes(address.id);
  });

  const deleteAddress = (id: string) => {
    const index = selectedAddresses.findIndex((address) => {
      return address.id === id;
    });
    selectedAddresses.splice(index, 1);
    onSetSelectedAddresses([...selectedAddresses]);
  };

  const selectTag = (id: string) => {
    const index = unSelectedAddresses.findIndex((address) => {
      return address.id === id;
    });
    onSelectAddress(unSelectedAddresses[index]);
    onSetSelectedAddresses([...selectedAddresses, unSelectedAddresses[index]]);
  };

  return (
    <div className={classNames("address-book", className)}>
      <div className="address-book__tag-container d-flex flex-wrap">
        {selectedAddresses.map((address) => {
          return (
            <AddressTag
              address={address}
              key={address.id}
              onDelete={deleteAddress}
              readOnly={readOnly}
            />
          );
        })}
      </div>

      {!readOnly && (
        <Select
          className="address-dropdown mt-2"
          values={unSelectedAddresses.map((address) => {
            return {
              id: address.id,
              title: address.alias || address.address,
            };
          })}
          placeholder="Add an address"
          onChange={selectTag}
          additionalItems={[
            {
              id: "newAddress",
              title: "+ New Address",
            },
          ]}
          onAdditionalItemClick={() => {
            onNewAddress();
          }}
        />
      )}
    </div>
  );
};

interface TagProps {
  address: Address;
  manageMode?: boolean;
  onDelete(address: string): void;
  readOnly?: boolean;
}

const AddressTag = ({ address, onDelete, readOnly = false }: TagProps) => {
  const network = address.network.split("-")[0]; // for "Mainnet-beta", cut off "beta" for compactness
  const explorerURL = makeAddress(
    address.chain,
    address.network,
    address.address,
  );
  const label = address.alias
    ? address.alias
    : reduceString(address.address, 5);
  return (
    <div className="address-tag">
      <span className="address-tag__network me-2">
        <div>{address.chain}</div>
        <div>{network}</div>
      </span>
      {explorerURL ? (
        <a href={explorerURL} target="_blank" rel="noreferrer">
          <span>{label}</span>
        </a>
      ) : (
        <span>{label}</span>
      )}
      {!readOnly && (
        <IoMdClose
          size={16}
          onClick={() => onDelete(address.id)}
          className="ms-1 my-auto tag-icon"
          title="Delete address"
        />
      )}
    </div>
  );
};
// const AddressTag = ({ address, onDelete }: TagProps) => {
//   return (
//     <div className="address-tag mb-2 d-flex justify-content-between">
//       <div className="address-tag-left">{address.alias || address.address}</div>
//       <div className="copy-icon">
//         <CopyToClipboard text={address.address}>
//           <MdContentCopy
//             size={16}
//             className="ms-1 my-auto tag-icon"
//             title="Copy address to clipboard"
//           />
//         </CopyToClipboard>
//       </div>
//       <div>
//         <IoMdClose
//           size={16}
//           onClick={() => onDelete(address.address)}
//           className="ms-1 my-auto tag-icon"
//           title="Delete address"
//         />
//       </div>
//     </div>
//   );
// };
